import { setLocalItem } from '@/utils/localStorage'
const Session = window.sessionStorage

const getSessionItem = (key: string) => {
  try {
    return JSON.parse(Session.getItem(key) as string)
  } catch (err) {
    return null
  }
}
const setSessionItem = (key: string, val: any) => {
  Session.setItem(key, JSON.stringify(val))
  // 获取赋值的信息
  const setDateList = ['zl-user-info', 'zl-login-date', 'zl-login-now-date', 'zl-nav-menu', 'zl-user-permission']
  if (setDateList.includes(key)) {
    setLocalItem(key, val)
  }
}
const clearSession = () => {
  Session.clear()
}
const sessionKeys = (index: number) => {
  return Session.key(index)
}
const removeSessionItem = (key: string) => {
  Session.removeItem(key)
}
export { getSessionItem, setSessionItem, clearSession, sessionKeys, removeSessionItem }
